/* unplugin-vue-components disabled */import script from "./message-plugin.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-plugin.vue?vue&type=script&lang=ts&setup=true"

import "./message-plugin.vue?vue&type=style&index=0&id=3616ce3f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3616ce3f"]])

export default __exports__